<script>
import axios from 'axios';
import {LocationPath} from '@/path.js';
import Swal from 'sweetalert2';

export default {
    props : ['warehouse'],
    components : {
        
    },
    data (){
        return {
            form : {
                warehouse_id : this.warehouse.id,
                country: 'India'
            },
            baseUrl : process.env.VUE_APP_API_BACKEND_URL,
            locations : [],
            fields : ["id","location","city","actions"],
            filter : [],
            currentPage : 1
        }
    },
    methods : {
        async getLocations(){
            try {
                let res = await axios.get(this.baseUrl + LocationPath.Locations,{
                    params : {
                        warehouse_id : this.warehouse.id
                    }
                });
                if(res.data.status){
                    this.locations = res.data.data;
                }
            } catch (error) {
                console.log(error);
            }
        },
        async saveLocation(){
            try {
                let res = await axios.post(this.baseUrl + LocationPath.Locations,this.form);
                if(res.data.status){
                    Swal.fire('Saved Successfully',"","success");
                    this.getLocations();
                }
            } catch (error) {
                console.log(error);
            }
        }
    },
    mounted(){
        this.getLocations();
    }
}
</script>

<template>
    <b-card>
        <b-card-header>
            <b-row>
                <b-col sm="4">
                    <label>Name</label>
                    <b-form-input v-model="form.location"></b-form-input>
                </b-col>
                <b-col sm="4">
                    <label>Address</label>
                    <b-form-input v-model="form.address"></b-form-input>
                </b-col>
                <b-col sm="4">
                    <label>Zip Code</label>
                    <b-form-input v-model="form.zip_code"></b-form-input>
                </b-col>
                <b-col sm="4">
                    <label>City</label>
                    <b-form-input v-model="form.city"></b-form-input>
                </b-col>
                <b-col sm="4">
                    <label>State</label>
                    <b-form-input v-model="form.state"></b-form-input>
                </b-col>
                <b-col sm="4">
                    <label>Country</label>
                    <b-form-input v-model="form.country"></b-form-input>
                </b-col>
                <b-col sm="4">
                    <b-button @click="saveLocation" variant="success">Save</b-button>
                </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
            <div class="table-responsive mb-0">
                <b-table
                    :key="locations.key"
                    :items="locations.data"
                    :fields="fields"
                    responsive="sm"
                    :filter="filter"
                    :current-page="currentPage"
                >
                </b-table>
            </div>
        </b-card-body>
    </b-card>
</template>

<style>
    
</style>